<!-- @format -->
<template>
    <div class="na-ad-box-dock has-text-centered">
        <router-link class="is-hidden-mobile" :to="{ name: 'sjsubscribe' }"
            ><img
                class="na-link na-ad-image"
                :src="imageUrl('NewsAtomic-SubscribeToSJ-250.jpg')"
                alt="Subscribe to the Shawangunk Journal"
                title="Subscribe to the Shawangunk Journal"
                width="250"
                height="250"
                loading="lazy"
        /></router-link>
        <router-link class="is-hidden-tablet" :to="{ name: 'sjsubscribe' }"
            ><img
                class="na-link na-ad-image"
                :src="imageUrl('NewsAtomic-SubscribeToSJ-250.jpg')"
                alt="Subscribe to the Shawangunk Journal"
                title="Subscribe to the Shawangunk Journal"
                width="250"
                height="250"
                loading="lazy"
        /></router-link>
    </div>
</template>

<script>
import { mediaMixin } from '@/mixins/MediaMixin.js';

export default {
    mixins: [mediaMixin]
};
</script>
